// Preserve the dua import while both readers share the same dock.
export { default } from '@components/shared/ReaderBottomDock/ReaderBottomDock'
export type { ReaderBottomDockProps as DuaBottomDockProps } from '@components/shared/ReaderBottomDock/ReaderBottomDock'
